import IpubLabel from './src/main'

/* istanbul ignore next */
IpubLabel.install = function(Vue) {
  Vue.component(IpubLabel.name, IpubLabel)
}

export default IpubLabel
